export function isSummaryBody(body) {
  try {
    const marker = JSON.parse(body)?._gateway_log;
    return (
      marker?.version === 1 &&
      ['request', 'response'].includes(marker.kind) &&
      ['summary', 'metadata'].includes(marker.mode) &&
      marker.content_omitted === true
    );
  } catch {
    return false;
  }
}

export function isSummaryLog(log) {
  return isSummaryBody(log?.request_body) || isSummaryBody(log?.response_body);
}

export function isRawStream(log) {
  return Boolean(log?.is_stream) && !isSummaryBody(log?.response_body);
}
